import { Badge } from '@utmost.co/utmost-design-system';
import { IconButton } from '@beeline.com/bp-design-system';
import React, { FC, useCallback } from 'react';
import styled from 'styled-components';
import { useHeaderIntl } from './translations/useHeaderIntl';

interface Props {
  onHelpClick: (target: HTMLElement) => void;
  isHelpOpen: boolean;
}

export const HelpButton: FC<React.PropsWithChildren<Props>> = ({ onHelpClick, isHelpOpen }) => {
  const intl = useHeaderIntl();
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      onHelpClick(event.currentTarget);
    },
    [onHelpClick]
  );
  const helpColor = 'colorOnBanner';

  return (
    <StyledBadge data-test={'help-button-container'}>
      <IconButton
        onClick={handleClick}
        dataTest="app-top-bar-help-button"
        tooltipText={intl.help}
        iconName="help"
        color={helpColor}
      />
    </StyledBadge>
  );
};

const StyledBadge = styled(Badge)`
  display: flex;
  justify-content: center;
  align-items: center;

  .MuiBadge-anchorOriginTopRightRectangle {
    transform: scale(1) translate(18%, 13%);
    pointer-events: none;
  }
`;
